import { isDisabled } from "@testing-library/user-event/dist/utils";
import { useEffect, useState } from "react";
import Select from "react-select";



function CustomSelect(props) {
    let {
        options,
        handleChange = () => { },
        isMulti = false,
        value = "",
        labelKey,
        valKey,
        isSearchable = true,
        isClearaAble = true,
        label = "",
        errorMsg = "",
        isBottomBorder,
        // Borderless field: bottom border appears only while focused
        isBottomBorderOnFocus = false,
        size = "medium",
        placeholder = "",
        isDisabled = false,
        isDeleteOption = false,
        handleDeleteFilter,
        showColorDot=false,
        hasMappedOpt=false
    } = props;

    options = hasMappedOpt? options: options?.map((i) => ({
        label: i[labelKey],
        value: i[valKey],
        details: i
    }));

    const [selectedValue, setSelecteValue] = useState([]);
    const [inputValue, setInputValue] = useState("");

    const transformOption = (value) => {
        if (!value) return [];
        return value?.map((level) => ({
            value: level,
            label: level,
        }));
    };

    const renderLabel = (option) => {
        if (!showColorDot) {
            return <span>{option.label}</span>;
        }

        const clr = option?.value?.split("_")[0];

        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                }}
            >
                <span
                    style={{
                        width: "6px",
                        height: "6px",
                        borderRadius: "50%",
                        backgroundColor: clr,
                        display: "inline-block",
                        flexShrink: 0,
                    }}
                />
                <span>{option.label.split("_")[1] || option.label}</span>
            </div>
        );
    };

    const formatOptionLabel = (option) => (
        <div className="option-row d-flex justify-content-between align-items-center">
            {renderLabel(option)}
            {
                isDeleteOption &&
                <button className="btn btn-primary-delete hide-show" style={{ height: '4px', width: '5px' }}
                    onClick={(e) => {
                        e.stopPropagation()
                        handleDeleteFilter(option.value, option)
                    }}
                >
                    -
                </button>
            }
        </div>
    );

    useEffect(() => {
        if (isMulti) {
            setSelecteValue(transformOption(value));
        }
    }, [value, isMulti]);


    const sizeStyles = {
        small1: { minHeight: "36px", fontSize: "var(--font-size-h4)" },
        small: { minHeight: "28px", fontSize: "var(--font-size-h4)" },
        medium: {
            minHeight: "36px", fontSize: "var(--font-size-base)"
        },
        large: { minHeight: "44px", fontSize: "var(--font-size-h3)" },
    };

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            backgroundColor: isBottomBorderOnFocus ? "transparent" : provided.backgroundColor,
            border: (isBottomBorder || isBottomBorderOnFocus) ? "none" : provided.border,
            borderBottom: isBottomBorderOnFocus
                ? `1px solid ${state.isFocused ? "var(--bs-primary)" : "transparent"}`
                : isBottomBorder ? "1px solid #3a4b68" : provided.border,
            borderTop: isBottomBorderOnFocus
                ? `1px solid ${state.isFocused ? "var(--bs-primary) " : "transparent"}`
                : isBottomBorder ? "none" : provided.border,
            borderRight: isBottomBorderOnFocus
                ? `1px solid ${state.isFocused ? "var(--bs-primary)" : "transparent"}`
                : isBottomBorder ? "none" : provided.border,
            borderLeft: isBottomBorderOnFocus
                ? `1px solid ${state.isFocused ? "var(--bs-primary)" : "transparent"}`
                : isBottomBorder ? "none" : provided.border,
            borderRadius: (isBottomBorder || isBottomBorderOnFocus) ? (isBottomBorderOnFocus&&state.isFocused)?'var(--ff-radius-sm)': 0 : 'var(--ff-radius-sm)',
            boxShadow: "none",
            minHeight: sizeStyles[size].minHeight,
            fontSize: '11px',
            "&:hover": {
                borderBottom: isBottomBorderOnFocus
                    ? `1px solid ${state.isFocused ? "#3a4b68" : "transparent"}`
                    : isBottomBorder
                        ? "1px solid #3a4b68"
                        : provided.border,
            },
        }),
        valueContainer: (provided) => ({
            ...provided,
            minHeight: sizeStyles[size].minHeight,

            padding: "6px 2px 6px 6px"
        }),
        placeholder: (provided) => ({
            ...provided,
            fontSize: "var(--font-size-base)", // or any size like "11px"
            color: "#667085",
        }),
        input: (provided) => ({
            ...provided,
            margin: 0,
            padding: 0,
        }),
        singleValue: (provided) => ({
            ...provided,
            color: 'rgba(var(--bs-black-rgb),var(--bs-text-opacity))!important',
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            height: sizeStyles[size].minHeight,
        }),
        option: (provided, state) => ({
            ...provided,
            fontSize: "var(--font-size-base)",     // 👈 smaller font
            padding: "0px 2px",   // 👈 reduce padding
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        dropdownIndicator: (provided) => ({
            ...provided,
            padding: "0px 6px",  // reduce padding around icon
            svg: {
                width: "14px",   // reduce icon size
                height: "14px",
            }
        }),
        indicatorSeparator: (provided) => ({
            ...provided,
            display: "none", // optional: hide the separator line
        }),
    };


    return (
        <div>
            <label htmlFor="" className="labelForASsign form-label">
                {label}
            </label>
            <Select
                options={options}
                isSearchable={isSearchable}
                formatOptionLabel={formatOptionLabel}
                isClearable={isClearaAble}
                isDisabled={isDisabled}
                value={
                    isMulti
                        ? selectedValue
                        : options?.find((i) => i.value === value) || null
                }
                isMulti={isMulti}
                onChange={(e) => {
                    if (isMulti) {
                        let arr = e?.map((item) => item.value) || [];
                        handleChange(arr, e);
                        setSelecteValue(transformOption(arr));
                    } else {

                        handleChange(e?.value || "", e);
                    }
                }}
                inputValue={isMulti ? inputValue : undefined}
                onInputChange={(newValue, { action }) => {
                    if (!isMulti) return;
                    // keep the typed text when an option is picked (action: "set-value"),
                    // clear it only on real input changes / when the menu closes
                    if (action === "input-change") {
                        setInputValue(newValue);
                    } else if (action === "menu-close" || action === "input-blur") {
                        setInputValue("");
                    }
                }}
                closeMenuOnSelect={!isMulti}
                hideSelectedOptions={false}
                classNamePrefix="select"
                className="w-100"
                styles={customStyles}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                placeholder={placeholder}
            />
            <div className="text-danger font-size-h4">{errorMsg}</div>
        </div>
    );
}

export default CustomSelect;
